<rcl-sub-nav tabindex="0" id="rcl-sub-nav">
  @for (guest of guests(); track guest; let i = $index) {
    <rcl-sub-nav-item
      [active]="guest.guestId === selectedGuestId()"
      [status]="getGuestStatus(guest)"
      [guestName]="guest.firstName"
      [disabled]="getGuestDisabled(guests(), i)"
      >
      <button
        [disabled]="getGuestDisabled(guests(), i)"
        [attr.aria-label]="isCurrent(guest) ? guest.firstName + ' selected' : guest.firstName"
        (click)="selectGuest(guest.guestId)"
        >
        {{ guest.firstName }}
      </button>
    </rcl-sub-nav-item>
  }
</rcl-sub-nav>
